"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlSelectOptionTpl", function () {
  return {
    restrict: "E",
    replace: false,
    transclude: true,
    scope: true,
    require: "^tlSelect",
    link: function link($scope, $el, $attrs, tlSelectCtrl, transcludeFn) {
      tlSelectCtrl.setOptionTranscludeFn(transcludeFn);
      $el.hide();
    }
  };
});
ngModule.directive("tlSelectGroupLabelTpl", function () {
  return {
    restrict: "E",
    replace: false,
    transclude: true,
    scope: true,
    require: "^tlSelect",
    link: function link($scope, $el, $attrs, tlSelectCtrl, transcludeFn) {
      tlSelectCtrl.setGroupLabelTranscludeFn(transcludeFn);
      $el.hide();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/tlSelectTemplates.js
// module id = 3001
// module chunks = 13